exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".assign-select .multiselect__option{padding-left:25px}.assign-select .multiselect__option--internalDisable{padding-left:10px}", ""]);

// exports
